import {
  shouldShowRoundZeroTutorial,
  shouldUseGuidedRun,
  type OnboardingState
} from "../game/onboarding";
import type { MusicScreen } from "./musicController";

type BackgroundRunPreparationInput = {
  hasActiveRunSession: boolean;
  isStartingRun: boolean;
  isTutorialRoundActive: boolean;
  onboarding: OnboardingState;
  screen: MusicScreen;
};

export function getBackgroundPreparedRunGuidance(
  input: BackgroundRunPreparationInput
): boolean | null {
  if (input.isTutorialRoundActive) {
    if (input.hasActiveRunSession || input.isStartingRun) {
      return null;
    }

    return true;
  }

  if (
    input.screen !== "title" ||
    input.hasActiveRunSession ||
    input.isStartingRun ||
    shouldShowRoundZeroTutorial(input.onboarding)
  ) {
    return null;
  }

  return shouldUseGuidedRun(input.onboarding);
}
